import deburr from "lodash/deburr"

import { buildQueryFilters, buildQueryString } from "~/lib/utils"

export default function MessageService(ctx) {
    return {
        async getMessages({ folder, query, cursor, date, limit, unread }) {
            const filter =
                buildQueryFilters({
                    free_search: query ? deburr(query) : null,
                    date: date ? `${date};GE` : null,
                    unread: unread ? true : null,
                }) || null
            const qs = buildQueryString({
                filter,
                cursor,
                limit,
            })
            const url = `/messages/${folder}?${qs}`
            return await ctx.fetchAPI(url)
        },

        async getUnreadMessages() {
            const { unreadMessages } = await ctx.fetchData(
                "/messages/inbox/unread"
            )
            return unreadMessages
        },

        async getMessageDetails({ messageUserId }) {
            return await ctx.fetchData(`/messages/${messageUserId}`)
        },

        async deleteMessage({ messageUserId, isDeleted }) {
            return await ctx.fetchData("/messages/delete", {
                method: "POST",
                body: JSON.stringify({
                    isDeleted,
                    messageUserIds: [messageUserId],
                }),
            })
        },

        async setReadStatus({ messageUserId, isRead }) {
            return await ctx.fetchData("/messages/read", {
                method: "POST",
                body: JSON.stringify({
                    isRead,
                    messageUserIds: [messageUserId],
                }),
            })
        },

        async newMessage({
            subject,
            body,
            attachments,
            to,
            repliedId,
            forwardedId,
            isPrivate,
        }) {
            return await ctx.fetchData("/messages", {
                method: "POST",
                body: JSON.stringify({
                    subject,
                    body,
                    attachments: attachments.map(a => {
                        return { fileHash: a.fileHash, fileName: a.name }
                    }),
                    recipients: {
                        includedUsers: to.includedUsers.map(
                            user => user.userId
                        ),
                        excludedUsers: to.excludedUsers.map(
                            user => user.userId
                        ),
                        filters: to.filters,
                    },
                    repliedId,
                    forwardedId,
                    isPrivate,
                }),
            })
        },
    }
}
